import { Grid, MuiThemeProvider, Slide, Typography, Paper, Button, CircularProgress, Icon } from '@material-ui/core';
import type { StyledComponentProps } from '@material-ui/core/styles';
import Spin from 'components/Spin';
import { theme } from 'components/Theme';
import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { list, clickNewzz } from 'store/Orbita/Newzz/actions';

import styles from '../styles';

import type IPagination from 'interfaces/IPagination';
import type { DispatchProp } from 'react-redux';

interface IProps extends DispatchProp<any>, StyledComponentProps {
  listNewzz: any;
  clickNewzz: any;
  newzz: any;
  listIsFetching: any;
  canLoadMore: any;
  pagination: any;
}

class Newzz extends React.Component<IProps, any> {
  componentDidMount() {
    this.props.listNewzz();
  }

  handleClickMore = () => {
    let pagination: IPagination = this.props.pagination;
    pagination.per_page = pagination.per_page + 10;
    this.props.listNewzz(pagination);
  };

  render() {
    const { newzz, classes, listIsFetching, canLoadMore } = this.props;
    const NewzzItem = (props: any) => (
      <Paper className={classes.paper} variant='outlined'>
        <Grid container alignItems='center' style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'row' }}>
          <Grid item xs={12} md={8} lg={10}>
            <Typography className={classes.heading}>{props.item.title}</Typography>
          </Grid>
          <Grid item xs={12} md={2} lg={1}>
            <Typography style={{ color: '#009358', fontWeight: 'bold' }} className={classes.heading}>
              {props.item.show_tag_new ? 'NOVO' : ''}
            </Typography>
          </Grid>
          <Grid item xs={12} md={2} lg={1}>
            <Typography className={classes.date}>{moment(props.item.created_at).format('L')}</Typography>
          </Grid>
        </Grid>
      </Paper>
    );
    return (
      <MuiThemeProvider theme={theme}>
        <div className={classes.root}>
          <Grid container justify='center' alignItems='center'>
            <div className={classes.title}>
              <h1>Newzz</h1>
              <p>Fique por dentro de todas as novidades da Eduzz</p>
            </div>
          </Grid>
          <div>
            <Grid container justify={'center'} alignItems='center'>
              <Grid item xs={12} md={8} lg={8}>
                {Array.isArray(newzz) &&
                  newzz.map((item: any, index: any) => (
                    <Slide key={`panel-${index}`} direction={'up'} in={true}>
                      {item.has_content ? (
                        <Link onClick={() => this.props.clickNewzz(item.id)} to={`/producer/news/info/${item.id}`}>
                          <NewzzItem item={item} />
                        </Link>
                      ) : (
                        <a onClick={() => this.props.clickNewzz(item.id)} href={item.external_url} target='_blank' rel='noopener noreferrer'>
                          <NewzzItem item={item} />
                        </a>
                      )}
                    </Slide>
                  ))}
              </Grid>
              {!listIsFetching && canLoadMore && (
                <Grid item xs={12} md={8} lg={8} className={classes.gridButton}>
                  <Button disabled={listIsFetching} onClick={this.handleClickMore} color='primary' className={classes.buttonLoad}>
                    {listIsFetching ? (
                      <CircularProgress size={18} color='inherit' style={{ fontSize: 16, color: '#192542', marginRight: '2px' }} />
                    ) : (
                      <Icon>expand_more</Icon>
                    )}
                    Carregar mais
                  </Button>
                </Grid>
              )}
              {listIsFetching && <Spin />}
            </Grid>
          </div>
        </div>
      </MuiThemeProvider>
    );
  }
}

function mapStateToProps(state: any) {
  const canLoadMore: boolean = (() => {
    const pg: IPagination = state.orbita.Newzz.list.pagination;
    if (pg) {
      return pg.per_page * pg.current_page < pg.total_items;
    }
    return false;
  })();
  return {
    newzz: state.orbita.Newzz.list.data,
    listIsFetching: state.orbita.Newzz.list.isFetching,
    pagination: state.orbita.Newzz.list.pagination,
    canLoadMore,
  };
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    listNewzz: (pagination?: IPagination) => dispatch(list(pagination)),
    clickNewzz: (value: number) => dispatch(clickNewzz(value)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(styles(Newzz));
